import { useEffect } from "react";
import intercom from "Utils/intercom";
import { useLocation } from "react-router-dom";
import { useUser } from "hooks/user";

const Intercom: React.FC = () => {
  const { data: user } = useUser();
  const location = useLocation();

  useEffect(() => {
    intercom.hide();
  }, [location]);

  useEffect(() => {
    intercom.shutdown();
    intercom.update(user?.UserProfile);
  }, [user?.UserProfile]);

  return null;
};

export default Intercom;
